<span class="code-system" [class.highlight]="shouldHighlight" (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()">{{codeSystem}}<span>
